import React from 'react'
import { Box, Button, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material'
import { useAuth0 } from '@auth0/auth0-react'
import { useTranslation } from 'react-i18next'
import { useLoginRoutine, buildRedirectURI } from './login-button-with-redirect'

export default function LandingPage() {
  const { loginWithRedirect } = useAuth0()
  const loginRoutine = useLoginRoutine()
  const { t, i18n } = useTranslation()

  const handleSignUp = () => {
    const audience = import.meta.env.VITE_AUTH0_API_AUDIENCE;
    loginWithRedirect({
      screen_hint: 'signup',
      redirect_uri: buildRedirectURI(),
      audience: audience,
      appState: { redirect: window.location.pathname },
    })
  }

  const handleLanguageChange = (_, newLang) => {
    if (newLang) {
      i18n.changeLanguage(newLang)
      localStorage.setItem('language', newLang)
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: '100vh', width: '100%' }}>
      {/* Left panel — branding */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'primary.light',
          color: 'primary.contrastText',
          p: 4,
          minHeight: { xs: '40vh', md: 'auto' },
        }}
      >
        <Box
          component="img"
          src="/favicon/android-chrome-192x192.png"
          alt="Wyes logo"
          sx={{ width: 120, height: 120, mb: 3 }}
        />
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          {t('AUTH.LANDING_TITLE')}
        </Typography>
        <Typography variant="h6" sx={{ maxWidth: 400, textAlign: 'center', opacity: 0.85 }}>
          {t('AUTH.LANDING_SUBTITLE')}
        </Typography>
      </Box>

      {/* Right panel — auth actions */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          {t('AUTH.LANDING_WELCOME')}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 360, textAlign: 'center' }}>
          {t('AUTH.LANDING_DESCRIPTION')}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: 320 }}>
          <Button variant="contained" size="large" fullWidth onClick={() => loginRoutine()}>
            {t('AUTH.SIGN_IN')}
          </Button>
          <Button variant="outlined" size="large" fullWidth onClick={handleSignUp}>
            {t('AUTH.SIGN_UP')}
          </Button>
        </Box>

        <ToggleButtonGroup
          value={i18n.language?.substring(0, 2)}
          exclusive
          onChange={handleLanguageChange}
          size="small"
          sx={{ mt: 4 }}
        >
          <ToggleButton value="fr">FR</ToggleButton>
          <ToggleButton value="en">EN</ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  )
}
